import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { ResponseAnalyticsService } from 'src/app/shared/services/response-analytics/response-analytics.service';
import * as _ from 'lodash';
import { ScoreDropdownMenuComponent } from '../../../../shared/components/score/score-dropdown-menu/score-dropdown-menu.component';
import { ActiveFiltersChipsComponent } from '../../../../shared/filters/ltms-global-filter-draw/sub-component/active-filters-chips/active-filters-chips.component';
import { AddFiltersButtonComponent } from '../../../../shared/filters/ltms-global-filter-draw/sub-component/add-filters-button/add-filters-button.component';
import { NgIf, NgClass, AsyncPipe } from '@angular/common';
import { ScoreTrendsComponent } from '../../../../shared/components/score/score-trends/score-trends.component';
import { ScoreDetailsComponent } from '../../../../shared/components/score/score-details/score-details.component';
import { ScoreOverviewComponent } from '../../../../shared/components/score/score-overview/score-overview.component';
import { ScoreComparisonToggleComponent } from '../../../../shared/components/score/score-comparison-toggle/score-comparison-toggle.component';
import {
  getShowComparisonFlag,
  isComparisonAvailable,
  setShowComparisonFlag,
} from '../../../../shared/utils/score-deviation.util';

@Component({
    selector: 'app-account-score-home',
    templateUrl: './account-score-home.component.html',
    styleUrls: ['./account-score-home.component.scss'],
    imports: [
        ScoreDropdownMenuComponent,
        ActiveFiltersChipsComponent,
        AddFiltersButtonComponent,
        NgIf,
        NgClass,
        ScoreTrendsComponent,
        ScoreDetailsComponent,
        ScoreOverviewComponent,
        ScoreComparisonToggleComponent,
        AsyncPipe,
    ]
})

export class AccountScoreHomeComponent implements OnInit {
  mainDiscription = '';
  // tabs = ['overview','trends', 'details'];
  tabs:any = [];
  params: any = {};  
  scaleRaterType: any = {};
  scalerTypeFieldId: number = 0;
  activeTab: string = '';
  currentTab: string = '';
  queryParams$: Observable<any> = of({});
  users = []
  tabVisisblity:any = {
    // overview:Helpers.isTabVisible(true,'scores','overview'),
    trends:Helpers.isTabVisible(true,'scores','summary'),
    details:Helpers.isTabVisible(true,'scores','comparison')
  }
  isTrendsTabShow: boolean = true;
  scaleSelectorConfig:any={
    width: '114px',
  }
  overviewShowComparison: boolean = false;
  constructor(
    private route: ActivatedRoute,
    private router: Router, 
    private responseAnalyticsService: ResponseAnalyticsService
  ) {}

  ngOnInit(): void {
    this.tabVisisblity = {
      overview:Helpers.isTabVisible(true,'scores','overview'),
      trends:Helpers.isTabVisible(true,'scores','summary_v2'),
      details:Helpers.isTabVisible(true,'scores','comparison')
    }
    // this is added for test purpose 
    // let loggedInUser = _.get(Helpers, "managerDetails.manager.email_address");

    // if(loggedInUser && this.users.indexOf(loggedInUser) != -1){
    //   this.tabVisisblity['overview']=Helpers.isTabVisible(true,'scores','overview');
    // }
    
    if(this.tabVisisblity.overview)
      this.tabs.push('overview');

    if(this.tabVisisblity.trends)
      this.tabs.push('trends');

    // if(this.tabVisisblity.questions)
    //   this.tabs.push('questions');

    // if(this.tabVisisblity.quickinsights)
    //   this.tabs.push('quickinsights');

    if(this.tabVisisblity.details)
      this.tabs.push('details');

    this.prepareScalerRaterType();
    this.currentTab = (this.tabs && this.tabs.length)?this.tabs[0]:''
    this.route.queryParams.subscribe(params => {
      this.params = params;
      if(this.params["account_id"]) {
        if(this.tabs.includes(this.params['active_tab'])) {
          this.activeTab = this.params['active_tab'] || this.currentTab;
          this.onClickingNavigation(this.activeTab);
        } else {
          this.activeTab = this.currentTab;
          this.onClickingNavigation(this.activeTab);
        }
      } else {
        console.log('Redirect to broken link page!');
      }
    });
  }

  private prepareScalerRaterType(): void {
    let scalerOptions: any[] = [];
    this.scaleSelectorConfig = {width: '114px'}
    const brandListDetail: any = _.get(Helpers, 'brandListDetail', null);
    if(brandListDetail) {
      brandListDetail.forEach(brandInfo => {
        const extenderRaterType: number | null = Number(brandInfo?.extender_rater_type) || null;
        const mainRaterType: number = !isNaN(Number(brandInfo?.main_rater_type)) ? Number(brandInfo?.main_rater_type) : 2;
        const scalerOptionName = extenderRaterType === 4 ? '1 to 5' : this.getRaterTypeName(mainRaterType);
        // Ticket ID: 71070 – If the project is closed and its visibility (show_on_dashboard) is off, then hide the scaler type for that project in the scaler selector dropdown.
        if (!scalerOptions.some(option => option.name === scalerOptionName) && (brandInfo?.show_on_dashboard === true || brandInfo?.show_on_dashboard == null)) {
          scalerOptions.push({ name: scalerOptionName, field_id: extenderRaterType === 4 ? 3 : mainRaterType === 0 ? 2 : mainRaterType });
        }
      })
      this.scaleRaterType = {
        selectedOption: scalerOptions[0].name,
        options: scalerOptions
      };
      if(scalerOptions.length <= 1){
        this.scaleSelectorConfig.isDisabled = true;
      }
      this.scalerTypeFieldId = this.scaleRaterType?.options[0]?.field_id;
      if(this.scalerTypeFieldId && this.scalerTypeFieldId != 2) {
        this.tabs = [];
        this.isTrendsTabShow = true;
        if(this.tabVisisblity.overview)
          this.tabs.push('overview');
    
        if(this.tabVisisblity.trends)
          this.tabs.push('trends');

        // if(this.tabVisisblity.questions)
        //   this.tabs.push('questions');
    
        // if(this.tabVisisblity.quickinsights)
        //   this.tabs.push('quickinsights');
    
        if(this.tabVisisblity.details)
          this.tabs.push('details');
      } else {
        this.tabs = [];
        this.isTrendsTabShow = false;
        if(this.tabVisisblity.overview)
          this.tabs.push('overview');

        // if(this.tabVisisblity.questions)
        //   this.tabs.push('questions');
    
        // if(this.tabVisisblity.quickinsights)
        //   this.tabs.push('quickinsights');
    
        if(this.tabVisisblity.details)
          this.tabs.push('details');
      }
      this.responseAnalyticsService.setRatingInfo(this.scalerTypeFieldId);
    }
  }
  
  private getRaterTypeName(value: number): string {
    switch (value) {
      case 1: return '-5 to +5';
      case 2: return 'Others';
      case 3: return '0 to 10';
      case 4: return '1 to 5';
      case 6: return '1 to 10';
      case 7: return '1 to 6';
      case 8: return '-3 to +3';
      case 9: return '1 to 4';
      default: return 'Others';
    }
  }

  onOptionChange(event: any): void {
    this.responseAnalyticsService.setRatingInfo(event.field_id);
    if(event && event?.field_id != 2) {
      this.tabs = [];
      this.isTrendsTabShow = true;
      if(this.tabVisisblity.overview)
        this.tabs.push('overview');
  
      if(this.tabVisisblity.trends)
        this.tabs.push('trends');

      // if(this.tabVisisblity.questions)
      //   this.tabs.push('questions');
  
      // if(this.tabVisisblity.quickinsights)
      //   this.tabs.push('quickinsights');
  
      if(this.tabVisisblity.details)
        this.tabs.push('details');
    } else {
      this.tabs = [];
      this.isTrendsTabShow = false;
      if(this.tabVisisblity.overview)
        this.tabs.push('overview');

      // if(this.tabVisisblity.questions)
      //   this.tabs.push('questions');
  
      // if(this.tabVisisblity.quickinsights)
      //   this.tabs.push('quickinsights');
  
      if(this.tabVisisblity.details)
        this.tabs.push('details');
    }
    /* 
      This will work only when the scaler type is Others.
      If the current selected tab is details and tabs array have length,
      and trends is not in the tab array then current tab will be details only.
      If the current tab is trends then select first avilable tab. 
    */
    if(this.currentTab && this.currentTab === 'details' && this.tabs && this.tabs.length > 0 && this.tabs.indexOf('trends') === -1) {
      this.currentTab = (this.tabs && this.tabs.length)?this.tabs[1]:''
    } else if(this.currentTab && this.tabs && this.tabs.length > 0 && this.tabs.indexOf('trends') === -1) {
      this.currentTab = (this.tabs && this.tabs.length)?this.tabs[0]:''
    }
    this.onClickingNavigation(this.currentTab);
  }


  onClickingNavigation(str: string) {
    this.currentTab = str;
    this.activeTab = str;
    this.overviewShowComparison = getShowComparisonFlag();
    this.setMainDiscrption();
    this.responseAnalyticsService.switchTab(this.activeTab);
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { active_tab: str },
      queryParamsHandling: 'merge'
    });
  }

  setMainDiscrption() {
    const discription = {
      "overview": '',
      "trends": 'Analyze the primary score, its components, and score distribution over time, with adjustable detail across multiple dimensions. Get a quick overview of the score and total responses for the selected period.',
      "details": 'View granular survey response metrics (average score, response counts, distribution) broken down by sub-accounts or projects for in-depth analysis of any tracked metric.'
    };
    this.mainDiscription = discription[this.activeTab]
  }

  isOverviewComparisonAvailable(): boolean {
    return isComparisonAvailable();
  }

  getOverviewDateType(): string {
    return (
      _.get(Helpers, 'datePicker.trendType') ||
      _.get(Helpers, 'datePicker.selectedTrend') ||
      'period'
    );
  }

  onOverviewShowComparisonChange(checked: boolean): void {
    this.overviewShowComparison = checked;
    setShowComparisonFlag(checked);
  }
}